import { useMemo } from 'react';

import {
  COUNTRY_ICONS,
  COUNTRY_SYMBOL_FLAGS,
} from '@app/components/Phone/constants/flags';
import { CountryAlpha2 } from '@app/types';
import { defineOperationSystem } from '@app/utils/defineOperationSystem';

import '@app/components/Phone/styles/Flag.desktop.scss';

const PF = 'flag';

export const Flag = ({ countryAlpha2 }: { countryAlpha2?: CountryAlpha2 }) => {
  const os = useMemo(defineOperationSystem, []);

  if (!countryAlpha2) {
    return (
      <img
        src={COUNTRY_ICONS[CountryAlpha2.UNKNOWN]}
        className={`${PF}_icon`}
      />
    );
  }

  if (os === 'apple') {
    const symbolFlag = COUNTRY_SYMBOL_FLAGS[countryAlpha2];
    if (countryAlpha2 === CountryAlpha2.UNKNOWN) {
      return (
        <img
          src={COUNTRY_ICONS[CountryAlpha2.UNKNOWN]}
          className={`${PF}_icon`}
        />
      );
    }

    return <span className={`${PF}_symbol`}>{symbolFlag}</span>;
  }

  const src = COUNTRY_ICONS[countryAlpha2];

  return (
    <img src={src} className={`${PF}_icon`} alt={`Flag of ${countryAlpha2}`} />
  );
};
